var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCluster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3873_154457)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.00008,
    cy: 8.00008,
    r: 7.545,
    fill: "url(#paint0_linear_3873_154457)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M6.72539 6.14906V10.5127H5.9349V6.91823H5.90934L4.88874 7.57022V6.84579L5.97326 6.14906H6.72539ZM7.83334 10.5127V9.94167L9.34826 8.45659C9.49314 8.31028 9.61388 8.18031 9.71047 8.06667C9.80706 7.95304 9.87951 7.84295 9.9278 7.73642C9.9761 7.62988 10.0002 7.51625 10.0002 7.39551C10.0002 7.25772 9.96899 7.13983 9.90649 7.04181C9.84399 6.94238 9.75806 6.86568 9.64868 6.8117C9.53931 6.75772 9.41502 6.73073 9.27581 6.73073C9.13235 6.73073 9.00664 6.76056 8.89868 6.82022C8.79073 6.87846 8.70692 6.96156 8.64726 7.06951C8.58902 7.17747 8.5599 7.30602 8.5599 7.45517H7.80777C7.80777 7.17818 7.87098 6.93741 7.9974 6.73287C8.12382 6.52832 8.29783 6.36994 8.51942 6.25772C8.74243 6.14551 8.99811 6.0894 9.28647 6.0894C9.57908 6.0894 9.83618 6.14409 10.0578 6.25346C10.2794 6.36284 10.4512 6.5127 10.5734 6.70304C10.697 6.89338 10.7588 7.11071 10.7588 7.35502C10.7588 7.51838 10.7275 7.67889 10.665 7.83656C10.6025 7.99423 10.4924 8.16895 10.3348 8.36071C10.1785 8.55247 9.95905 8.78471 9.67638 9.05744L8.92425 9.82235V9.85218H10.8248V10.5127H7.83334Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3873_154457",
    x1: 8.00008,
    y1: 0.455078,
    x2: 8.00008,
    y2: 15.5451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82BAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754808,
    stopColor: "#264C86"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3873_154457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCluster);
export default __webpack_public_path__ + "static/media/Cluster.961bea1195337207b38ca78af16761bc.svg";
export { ForwardRef as ReactComponent };